import React, { FC, useMemo, useCallback, memo } from 'react';
import { useLazyQuery } from '@apollo/client';
import _sortBy from 'lodash/sortBy';
import DropdownWithChildren from '@minecraft.dropdown-with-children';
import ErrorMessage from '@minecraft.error-message';
import { QUERY_ETHNIC_APPEARANCES } from '../FilterBasicCollectionGraphQL';
import { generateSelectOptionsBasedOnField, getFilteredArrayByEnabled } from '../../../shared/utils';
import { FilterData } from '../../../shared/types';

type Props = FilterData;

const EthnicAppearance: FC<Props> = ({ name, label }) => {
  const [getEthnicAppearance, { data, loading, error }] = useLazyQuery(QUERY_ETHNIC_APPEARANCES);

  const handleEthnicAppearanceFetch = useCallback((): void => {
    if (!data) {
      getEthnicAppearance();
    }
  }, [data]);

  const ethnicAppearanceOptions = useMemo(() => {
    return generateSelectOptionsBasedOnField(
      _sortBy(getFilteredArrayByEnabled(data?.ethnicAppearances), 'sortOrder'),
      'name',
      false,
      undefined,
      true
    );
  }, [data]);

  if (error) return <ErrorMessage error={error} />;

  return (
    <DropdownWithChildren
      withFormik
      withSearch
      withSelectAll
      isLoading={loading}
      name={name}
      toggleLabel={label}
      options={ethnicAppearanceOptions}
      onOptionsFetch={handleEthnicAppearanceFetch}
    />
  );
};

export default memo(EthnicAppearance);
